<template>
  <!--
      作者 rj.wu
      时间：2021-02-01
      描述：会员-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <div>
          <el-form-item label="昵称或手机">
            <el-input v-model="formInline.nickName" placeholder="请输入昵称或手机"></el-input>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
          </el-form-item>
          <el-form-item label="起始日期">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker v-model="formInline.create_time" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </div>
        <div >
            <el-form-item label="区域">
              <el-select v-model="formInline.province_id" placeholder="省" @change="initCity">
                <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
              </el-select>
              <el-select v-if="formInline.province_id!=''" v-model="formInline.city_id" placeholder="市" @change="initRegion">
                <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[formInline.province_id]['city']"
                  :key='index1'></el-option>
              </el-select>
              <el-select v-if="formInline.city_id!=''" v-model="formInline.region_id" placeholder="区">
                <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[formInline.province_id]['city'][formInline.city_id]['region']"
                  :key='index2'></el-option>
              </el-select>
            </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="80">
            <template slot-scope="scope" v-if="scope.row.user">
              <img v-img-url="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>等级：{{grade[scope.row.user.grade_id]['name']}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="order_no" label="订单号">
            <template slot-scope="scope">
              <a href="#" @click="gotoPage(scope.row)" v-if="scope.row.order_no">
                {{scope.row.order_no}}
              </a>
            </template>
          </el-table-column>
          <el-table-column prop="log_type.text" label="类型" width="120" align="center"></el-table-column>
          <el-table-column prop="price" label="积分" width="120" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="params" label="相关">
            <template slot-scope="scope">
              <span v-if="scope.row.region">
                {{scope.row.region.merger_name}}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="is_settled" label="是否结算" width="130">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.is_settled">已结算</span>
              <span class="gray9" v-else>未结算</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="140" sortable="custom"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import qs from 'qs';
  export default {

    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          nickName: '',
          user_id: '',
          scene: '',
          create_time: [],
          province_id:'',
          city_id:'',
          region_id:''
        },
        areaList:[],
        /*场景*/
        Scene: [],
        /*时间*/
        create_time: '',
        /*等级*/
        grade:[],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getTableList();

    },
    methods: {
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/user.agent_log/regionlogexport?' + qs.stringify(this.formInline);
      },
      /*初始化城市id*/
      initCity() {
        this.formInline.city_id = '';
        this.formInline.region_id = '';
      },

      /*初始化区id*/
      initRegion() {
        this.formInline.region_id = ''
      },
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        UserApi.RegionLog(Params, true).then(data => {
          self.areaList = data.data.regionData;
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.Scene = data.data.attributes;
          self.grade = data.data.grade;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/agent/part/Regionlog.vue